import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../theme/Theme.jsx';

function SectionTitleSimple(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		fontSize: context.themeManager.value('section-title-simple', 'fontSize', 'font-size-100'),
		padding: '0 0 0.4em 0',
		margin: '0 0 0.8em 0',
		borderBottom: context.themeManager.valueOrDefault('section-title-simple', 'border', null, '1px solid #d5d5d5')
	};
	const Headline = props.headlineLevel? props.headlineLevel : 'h1';
	return (
		<Headline className="section__title" style={style}>
			{props.children}
		</Headline>
	);
}

export default radium(SectionTitleSimple);
